var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogProfileUserAttach__Component" }, [
    _c(
      "form",
      {
        attrs: { novalidate: "true" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.save($event)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("שיוך משתמש קיים")
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            })
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            _c(
              "div",
              { staticClass: "DialogProfileUserAttach__Component__Loading" },
              [
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "חפש משתמש לפי שם/אימייל/מזהה" } },
                      [
                        _c("b-input", {
                          attrs: { type: "text", placeholder: "חפש משתמש" },
                          on: {
                            input: function($event) {
                              return _vm.searchUsers(_vm.searchTerm)
                            }
                          },
                          model: {
                            value: _vm.searchTerm,
                            callback: function($$v) {
                              _vm.searchTerm = $$v
                            },
                            expression: "searchTerm"
                          }
                        })
                      ],
                      1
                    ),
                    _c("b-table", {
                      attrs: {
                        loading: _vm.isLoading,
                        data: _vm.searchResults,
                        columns: [
                          {
                            label: "שם משתמש",
                            field: "FullName"
                          },
                          {
                            label: "אימייל",
                            field: "Email"
                          },
                          {
                            label: "מזהה",
                            field: "Id"
                          }
                        ],
                        selected: _vm.selectedUser,
                        focusable: ""
                      },
                      on: {
                        "update:selected": function($event) {
                          _vm.selectedUser = $event
                        },
                        click: _vm.onUserClick
                      }
                    })
                  ],
                  1
                )
              ]
            )
          ]),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  "native-type": "submit",
                  loading: _vm.isLoading,
                  label: "שמור",
                  type: "is-primary"
                }
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isLoading, label: "סגור" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }